export default __webpack_public_path__ + "static/s2-5df2a2948a787845e7b53115496c2c7a.jpg";